import React, { useState } from 'react';

import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import LogoCanvas from "./components/LogoCanvas";
import Row from 'react-bootstrap/Row';
import 'bootstrap/dist/css/bootstrap.min.css';

import LogoInterpreter from './services/LogoInterpreter';
import './App.css';

function App() {
  const [error, setError] = useState<string>("");
  const [instructions, setInstructions] = useState<any[]>([]);

  function parseScript(): void {
    const newScript = (document.getElementById("txtScript") as HTMLInputElement).value;
    const parseResult = LogoInterpreter.parse(newScript);
    setError(parseResult.error);
    setInstructions(parseResult.instructions);
  }

  function onKeyDown(event: React.KeyboardEvent<HTMLDivElement>): void {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    if (event.key === 'Enter' || event.key === "NumpadEnter") {
      event.preventDefault();
      event.stopPropagation();
      parseScript();
    }
  }

  return (
    <Container fluid>
      <Row>
        <Col>
          <input id="txtScript" type="text" defaultValue="PD REPEAT 3 [FD 80 RT 72] PU" onKeyDown={onKeyDown} />
          <Button variant="primary" onClick={parseScript}>Go</Button>{' '}
        </Col>
      </Row>
      <Row>
        <Col>
          <LogoCanvas instructions={instructions} />
        </Col>
        <Col>
          {
            instructions.map((value: any, index: number, array: any[]) => {
              return <div key={index}>{JSON.stringify(value)}</div>;
            })
          }
          {error && <div className="errors">{error}</div>}
        </Col>
      </Row>
    </Container>
  );
}

export default App;
